import React from "react";
import { Inbox } from "lucide-react";

interface EmptyListProps {
  title?: string;
  description?: string;
  icon?: React.ReactNode;
}

const EmptyList: React.FC<EmptyListProps> = ({
  title = "No items found",
  description = "There are no items to display at the moment.",
  icon = <Inbox className="w-12 h-12 text-gray-400" />,
}) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4">
      <div className="mb-4">{icon}</div>
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-1">
        {title}
      </h3>
      <p className="text-sm text-gray-500 dark:text-gray-400 text-center max-w-sm">
        {description}
      </p>
    </div>
  );
};

export default EmptyList;
